export default class ReviewSerializer {
  static deserialize(response) {
    const result = {
      id: response.id,
      eventTitle: response.event_title,
      ATName: response.at_name,
      EOName: response.eo_name,
      shiftTime: response.shift_times,
    }
    return result;
  };

  static serialize(review) {
    const result = {
      eo_additional_feedback: review.additionalFeedback,
      eo_rating: review.rating,
    };
    return result;
  };
}